import { useMutation } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";

export interface IVerifyRazorpayPaymentPayload {
  razorpay_payment_id: string;
  razorpay_subscription_id: string;
  razorpay_signature: string;
}

export const useVerifyRazorpayPayment = () => {
  return useMutation<void, Error, IVerifyRazorpayPaymentPayload>({
    mutationFn: async (payload) => {
      await httpService.post(
        API_CONFIG.path.razorpayVerify,
        payload as unknown as Record<string, unknown>
      );
    },
  });
};
